import { convertValueToLocale } from "helpers/convertValueToLocale";

import { Typography } from "shared/ui/components/Typography";

import styles from "./LoansCard.module.scss";

const LoansCard = ({ loans, loanYears }: { loans: any, loanYears: number }) => {
  return (
    <div className={styles.root}>
      <Typography variant="bodyL" weight="semiBold" className={styles.title}>
        FINANZIERUNGS- UND STEUERDATEN
      </Typography>
      {loans.map((loan: any, index: number) => (
        <div key={index}>
          <Typography
            variant="bodyM"
            weight="semiBold"
            className={styles.title}
          >
            {loan.title}
          </Typography>
          <div className={styles.inner}>
            <div className={styles.column}>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Darlehensbetrag
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {convertValueToLocale(loan.amount, null, "€", null)}
                </Typography>
              </div>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Finanzierungsbeginn
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {loan.startDate}
                </Typography>
              </div>
            </div>
            <div className={styles.column}>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Zinsbindungsdauer
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  10 Jahre
                </Typography>
              </div>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Sollzins
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {convertValueToLocale(loan.startRate, null, "%", null)}
                </Typography>
              </div>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Anfängl. Tilgungssatz
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {convertValueToLocale(loan.startMinRate, null, "%", null)}
                </Typography>
              </div>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Anschlusszeitraum
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {`11. bis ${loanYears}. Jahr`}
                </Typography>
              </div>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Anschluss Sollzins
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {convertValueToLocale(loan.rate, null, "%", null)}
                </Typography>
              </div>
              <div className={styles.row}>
                <Typography variant="bodyM" weight="semiBold">
                  Anschluss Tilgungssatz
                </Typography>
                <Typography
                  variant="bodyM"
                  weight="regular"
                  className={styles.value}
                >
                  {convertValueToLocale(loan.minRate, null, "%", null)}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoansCard;
